@if (transactionDataSource()) {
  <div class="transaction-list relative flex min-h-0 flex-1 flex-col" [class.inDrawer]="options().isInDrawer">
    <div
      class="transaction-list-loading-wrapper relative z-10 mx-auto flex h-0 w-full max-w-transaction-list items-center justify-end"
    >
      @if (transactionDataSource().transactionsLoading$ | async) {
        <span
          class="transaction-list-loading absolute right-4 top-4 inline-flex h-8 w-8 rounded-full border-2 border-border border-t-brand-accent-strong"
          role="status"
          aria-label="Loading transactions"
        ></span>
      }
    </div>
    <!-- Rows and date headers share --app-size-transaction-row-height (72px), so a fixed item size fits both. -->
    <cdk-virtual-scroll-viewport
      itemSize="72"
      minBufferPx="1200"
      maxBufferPx="1800"
      class="transaction-list-viewport min-h-0 flex-1 overflow-x-hidden pb-transaction-list-bottom"
    >
      <div
        class="transaction-list-viewport-wrapper relative mx-auto max-w-transaction-list overflow-hidden border border-border bg-surface-elevated shadow-raised min-[664px]:rounded-b-lg"
      >
        <div
          class="transaction-list-item-wrapper h-transaction-row [&>*]:box-border [&>*]:h-full"
          *cdkVirtualFor="let transaction of transactionDataSource(); templateCacheSize: 0; trackBy: trackByListRow"
        >
          @if (isDateHeader(transaction)) {
            <div
              class="transaction-list-header flex h-full items-center justify-between gap-4 border-b border-border-muted bg-surface-muted px-6 text-[11px] font-semibold uppercase tracking-[0.08em] text-text-muted"
            >
              <span class="flex items-center gap-1.5">
                <span>{{ transaction.date | date: 'mediumDate' }}</span>
                @if (transaction.count) {
                  <span class="opacity-40" aria-hidden="true">·</span>
                  <span class="opacity-70 tabular-nums">{{ transaction.count }}</span>
                }
              </span>
              <span class="flex items-center justify-end gap-4">
                @if (transaction.count) {
                  <span class="tabular-nums">
                    {{ (transaction.total ?? 0) > 0 ? '+' : '' }}{{ transaction.total | currency }}
                  </span>
                }
                @if (pendingCountForDate(transaction.date); as pendingCount) {
                  <button
                    appUiButton
                    appearance="solid"
                    tone="accent"
                    size="compact"
                    type="button"
                    class="ml-auto whitespace-nowrap normal-case tracking-normal text-body-sm"
                    (click)="acceptDay(transaction.date)"
                    [attr.aria-label]="
                      'Accept ' +
                      pendingCount +
                      ' suggested ' +
                      (pendingCount === 1 ? 'transaction' : 'transactions') +
                      ' for ' +
                      (transaction.date | date: 'longDate')
                    "
                  >
                    <ng-icon hlm size="sm" name="lucideCircleCheck" class="mr-1" />
                    Accept {{ pendingCount }}
                  </button>
                }
              </span>
            </div>
          }
          @if (isTransaction(transaction)) {
            <app-transaction-list-item
              [transactionDataSource]="transactionDataSource()"
              [transaction]="transaction"
              [buckets]="buckets()"
              [bucketIdentities]="bucketIdentities()"
              [isSelected]="(transactionDataSource().isSelected$(transaction) | async) ?? false"
              [selectionMode]="(transactionDataSource().multiSelectEnabled$ | async) ?? false"
              [showBucketSelector]="showInlineBucketSelector()"
              (selectionToggled)="transactionDataSource().toggleSelected($event)"
            />
          }
        </div>
      </div>
    </cdk-virtual-scroll-viewport>
    @if (hasSelectedTransactions$(transactionDataSource()) | async) {
      <div
        class="transaction-list-actions z-40 mx-auto grid w-full max-w-transaction-list shrink-0 grid-cols-[auto_1fr] items-center gap-x-2 gap-y-1 border-t border-border bg-surface-muted-strong px-4 py-2 shadow-raised min-[664px]:flex min-[664px]:h-transaction-actions min-[664px]:py-0"
      >
        @if (transactionDataSource().selectedTransactions$ | async; as selectedTransactions) {
          <button
            appUiButton
            appearance="ghost"
            tone="neutral"
            size="responsive"
            iconOnly
            type="button"
            class="transaction-list-action-button"
            aria-label="Clear selection"
            (click)="transactionDataSource().clearSelected()"
          >
            <ng-icon hlm size="sm" name="lucideX" />
          </button>
          <span class="text-body-sm font-semibold text-text">{{ selectedTransactions.length }} selected</span>
          <div class="col-span-2 flex min-w-0 items-end justify-end gap-2 min-[664px]:ml-auto min-[664px]:items-center">
            @if (showInlineBucketSelector()) {
              <div class="flex min-w-0 flex-col gap-1 min-[664px]:flex-row min-[664px]:items-center">
                <span class="text-label-sm font-semibold text-text-muted min-[664px]:sr-only">Budget</span>
                <bucket-selector
                  class="bulk-budget-selector"
                  size="responsive"
                  [transactions]="(selectedTransactions$(transactionDataSource()) | async) ?? []"
                  [buckets]="buckets()"
                  [needsSaving]="!!(selectedBucket$ | async)"
                  [selectedBucket]="(selectedBucket$ | async) ?? undefined"
                  (changeSelectedBucket)="changeSelectedBucket($event)"
                  (saveBucket)="onSaveBucket($event, selectedTransactions)"
                  (changeSuggestedBuckets)="onSuggestedBucketChange($event)"
                />
              </div>
            }
            <button
              appUiButton
              appearance="ghost"
              tone="neutral"
              size="responsive"
              type="button"
              class="transaction-list-action-button"
              aria-label="Edit selected transactions"
              (click)="openEditDialog()"
            >
              <ng-icon hlm size="sm" name="lucidePencil" />
              <span>Edit</span>
            </button>
          </div>
        }
      </div>
    }
  </div>
}
